@import '../../../../node_modules/@chatscope/chat-ui-kit-styles/dist/default/styles.css';

.cs-main-container {
  border: 10px !important;
}

.cs-main-container input {
  height: 48px !important;
  border-radius: 8px !important;
  border: 1px solid var(--mantine-color-gray-3) !important;
}

.cs-message-input__content-editor-wrapper {
  border-radius: 8px !important;
  border: 1px solid #d0d5dd !important;
  background: white !important;
  /* Shadow/sm */
  box-shadow:
    0px 1px 3px 0px rgba(16, 24, 40, 0.1),
    0px 1px 2px 0px rgba(16, 24, 40, 0.06) !important;
}

.cs-message-input__content-editor {
  background-color: white !important;
}

.cs-message-input {
  border-top: 0px !important;
  flex: 1 !important;
}

.cs-message__content {
  font-family: var(--mantine-font-family) !important;
  background-color: black !important;
  color: white !important;
  border-radius: 12px 12px 6px 12px !important;
}

.cs-message-list {
  background-color: var(--mantine-color-gray-0) !important;
}

.mantine-datatable-row-expansion-cell-content {
  border-bottom: 0 !important;
}

ul.frames {
  font-size: 0 !important;
}
ul.frames li {
  font-size: 14px;
  font-size: 1.4rem !important;
  display: inline !important;
}

.cs-message__content {
  white-space: normal !important;
}

.cs-message__content th {
  text-align: left !important;
}

.cs-message__content table {
  border-spacing: 25px 0 !important;
}

.cs-message__content :first-child {
  margin-top: 0 !important;
}

.cs-message__content :last-child {
  margin-bottom: 0 !important;
}

.cs-message--incoming {
  width: 100% !important;
  max-width: unset !important;
}

.cs-message--incoming .cs-message__content {
  background-color: transparent !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.cs-message--incoming .cs-message__content-wrapper {
  width: 100% !important;
}
